export default __webpack_public_path__ + "static/media/backIcon.4338752c.svg";